import bsc from "../images/bsc.png"
import polygon from "../images/polygon.png"
import bsctestnet from "../images/bsctestnet.png"
import eth from "../images/eth.png"
import ropsten from "../images/ropsten.png"
// export const RPC_URL = "https://bsc-dataseed1.binance.org/";
// export const CHAIN_ID = 56;
import sepolia from "../images/eth.png"


export const RPC_URL = "https://sepolia.infura.io/v3/";
export const CHAIN_ID = 11155111;

export const ONEDAYINSECONDS = 86400;
export const frontendurl = window.location.origin;

export const AdminSaleAddress = "" //"0x5cb3aDAE7fba7439727E62d4FA57d93D3d608084"  //"0x92eAEAbf96AaE481D01e1F5C5aE73C43ecEf645d" //0x22aD5493f105E9EE3fC03e35A87fD45EB65B64a3"

export const AdminTokenAddress = "0x100a9E44DdB4889250984c6EA5BF1879C14296f5"   //"0xe43a3EA9a3e411E79Bc732d54D00B8a03DD4E79C" //"0x323655b1169D2f7131C6bd3A20b2F2922AFAf3Eb" //"0x0b754ba95eD079FacCAc71245280dd367e1d4134"

export const userFee = 5

export const userFeeWithtoken = 4
//Live
 // export const mainurl = "https://lumina.exchange"
//demo
  export const mainurl = "https://lumina-frontend.pages.dev"

  export const perpsurl = "https://lumina-futuretrading-frontend.pages.dev/"


export const CHAINS = [
    // {
    //     NAME: "BSC-Testnet",
    //     RPC_URL: [
    //         "https://neat-fragrant-crater.bsc-testnet.quiknode.pro/b5baa8a7cdddef6b65cdb7ac9f8e598244df6e4f/",
    //         "https://bsc-testnet.publicnode.com",
    //         "https://data-seed-prebsc-1-s2.bnbchain.org:8545",
    //         "https://bsc-testnet.blockpi.network/v1/rpc/public"
    //     ],
    //     CHAIN_ID: 97,
    //     IMAGE: bsctestnet,
    //     ROUTER: "0x097b0468D402B7a13969C3D8B145717a6ef928DD", //0x15690Bc1eA3083c747A31927a641c0566bf86A10",//"0x29035dEbC68181B33183E3A7fb9291bC2815644F", //pancake
    //     // ROUTER: "0x2a09fba034e26852ff38d5393f3fd15748518791"
    //     LIQUIDITY_TOKEN_ADDRESS: "0xaBa998C38A086e72f5F35A8B13D56B3c97eB418e",
    //     STANDARD_TOKEN_ADDRESS: "0x487e12D2B7128F004E39473D2f0De3C3Ac012C71",
    //     LOCK_ADDRESS: "0x946695Add5b02Ae1390947f3D92402f3b32653ba", //0xC2B481541855d26F27fD6903bF5045957415962d // "0xEC12Dc84482668C7D9c4b319bD72F3ab808a44cE", // 0xd915682d1b33e142f0B1F4822502702e11e2F9e8 old
    //     BNB: "0x0000000000000000000000000000000000000000",
    //     // BUSD : "0xbCf448aa88d80C1B7bb8Fb5A1e68cd4B6c11c354",
    //     USDT: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
    //     USDC: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
    //     DAI: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
    //     AIRDROP_ADDRESS: "0xd13BE9C8146c0E99B08Dd8E98544A84caB3E3488", //"0x385b0e7d746ed4711ed3e7bea48e2d9b5052373a",
    //     TRANSACTION: "https://testnet.bscscan.com/tx/",
    //     TokenTracker: "https://testnet.bscscan.com/token/",
    //     Testnet: "https://testnet.bscscan.com/address/",
    // },

// Lumina Demo
    {
        NAME: "BSC-Testnet",
            RPC_URL: [
                "wss://bsc-testnet-rpc.publicnode.com",
                "https://endpoints.omniatech.io/v1/bsc/testnet/public ",
            "https://bsc-testnet.publicnode.com",
                 "https://data-seed-prebsc-1-s2.bnbchain.org:8545",
                "https://bsc-testnet.blockpi.network/v1/rpc/public"
             ],
        CHAIN_ID: 97,
        IMAGE: bsctestnet,
        ROUTER: "0x097b0468D402B7a13969C3D8B145717a6ef928DD",
        LIQUIDITY_TOKEN_ADDRESS: "0xE287d5946fA217F7E509f3a970A448F31b22Ed01",
        STANDARD_TOKEN_ADDRESS: "0xcf67afD27908a86109b38a8B26d256658F66d000",
        LOCK_ADDRESS: "0x8B2F807bf95395e32F31afd021832410A500851A",
        BNB: "0x0000000000000000000000000000000000000000",
        USDT: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
        USDC: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
        DAI: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
        LUMINA: "0x0A4dD2F74558e181C50D3efd7551ceE73A2F8f66",
        AIRDROP_ADDRESS: "0xd13BE9C8146c0E99B08Dd8E98544A84caB3E3488",
        TRANSACTION: "https://testnet.bscscan.com/tx/",
        TokenTracker: "https://testnet.bscscan.com/token/",
        Testnet: "https://testnet.bscscan.com/address/",
        VOTING : "0xe2086Ed679386082c5A58877bF0b33E7A9c3BfB5"
    },

    {
        NAME: "ETH-Testnet",
            RPC_URL: [
                "https://sepolia.infura.io/v3/"
             ],
             CHAIN_ID: 11155111,
        IMAGE: sepolia,
        ROUTER: "0x866f7953220F5f0DDE2Fe97c1aFabd4b34EAC39F",
        LIQUIDITY_TOKEN_ADDRESS: "0x41D3e7Ed88218bc74016Eafe09E87Fc48B0EC8b4",
        STANDARD_TOKEN_ADDRESS: "0xeaF5aCc0A564F528A36465C4f4D366F33b75cc16",
        LOCK_ADDRESS: "0x8B2F807bf95395e32F31afd021832410A500851A",
        BNB: "0x0000000000000000000000000000000000000000",
        USDT: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
        USDC: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
        DAI: "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
        LUMINA: "0xE478d54723F0Ed1DC5026445785e94AF346d11C2",
        AIRDROP_ADDRESS: "0xd13BE9C8146c0E99B08Dd8E98544A84caB3E3488",
        TRANSACTION: "https://explorer.zksync.io/tx/",
        TokenTracker: "https://explorer.zksync.io/token/",
        Testnet: "https://etherscan.io/",
    },

    // lumina live

    // {
    //     NAME: "BNB",
    //         RPC_URL: [
    //             "https://bsc-pokt.nodies.app"
    //          ],
    //          CHAIN_ID: 56,
    //     IMAGE: bsctestnet,
    //     ROUTER: "0xcAC08FB0C62b750B43732881f7660B30D5a11A83",
    //     LIQUIDITY_TOKEN_ADDRESS: "0xFC9948786B191Cffe68d116325E4Cd01B7Dc12a0",
    //     STANDARD_TOKEN_ADDRESS: "0xbfd18F2dE85BDE46cB75BcBbD2F77fC2dBdE70B1",
    //     LOCK_ADDRESS: "0x8B2F807bf95395e32F31afd021832410A500851A",
    //     BNB: "0x0000000000000000000000000000000000000000",
    //     USDT: "0xfD5840Cd36d94D7229439859C0112a4185BC0255",
    //     USDC: "0x8965349fb649A33a30cbFDa057D8eC2C48AbE2A2",
    //     DAI: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
    //     LUMINA: "0x889FA266F540f18Fc88B62E5D8cb231ccB2c163A",
    //     AIRDROP_ADDRESS: "0xd13BE9C8146c0E99B08Dd8E98544A84caB3E3488",
    //     TRANSACTION: "https://bscscan.com/tx/",
    //     TokenTracker: "https://bscscan.com/token/",
    //     Testnet: "https://bscscan.com/address/",
    //     VOTING : "0x0b991e973D7E6D446b7EAFEB713D6Ac7D9bEb4B4"
    // },

    // {
    //     NAME: "ETH",
    //         RPC_URL: [
    //             "https://eth.llamarpc.com"
    //          ],
    //          CHAIN_ID: 1,
    //     IMAGE: sepolia,
    //     ROUTER: "0x15690Bc1eA3083c747A31927a641c0566bf86A10",
    //     LIQUIDITY_TOKEN_ADDRESS: "0x356fDB9Dac4692C526d4d3Bb612877dF539592d5",
    //     STANDARD_TOKEN_ADDRESS: "0xe47a83a819c84B154B0a9966D76166fb590E3D8E",
    //     LOCK_ADDRESS: "0x8B2F807bf95395e32F31afd021832410A500851A",
    //     BNB: "0x0000000000000000000000000000000000000000",
    //     USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    //     USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    //     DAI: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    //     LUMINA: "0x6428ca3826f67d71B6cAeDeFba58d6f7ad1eeF51",
    //     AIRDROP_ADDRESS: "0xd13BE9C8146c0E99B08Dd8E98544A84caB3E3488",
    //     TRANSACTION: "https://etherscan.io/tx/",
    //     TokenTracker: "https://etherscan.io/token/",
    //     Testnet: "https://etherscan.io/address/",
    //     VOTING : "0xA630BB14Bb57588E000737A94fF9663Ef91904B0"
    // },



     

   
   



    // {
    //     NAME: "Avalanche-TEST",
    //     RPC_URL:"https://api.avax-test.network/ext/bc/C/rpc",
    //     CHAIN_ID:43113,
    //     SYMBOL:"AVAX",
    //     IMAGE: bsctestnet,
    //     ROUTER: "0xC40B73d75Ffc7d01987ec172D7f9931f39e6ab8e",//"0x6428ca3826f67d71B6cAeDeFba58d6f7ad1eeF51",//0x29035dEbC68181B33183E3A7fb9291bC2815644F", //pancake
    //     // ROUTER: "0x2a09fba034e26852ff38d5393f3fd15748518791"
    //     LIQUIDITY_TOKEN_ADDRESS :"0x13f6Ba478720Da0FE477E6756cea72Ac6aA08Fc2", //"0x06Fb02c073Cda5B84D323C407437E05DA6388ca1",
    //     STANDARD_TOKEN_ADDRESS : "0x38dC9f77d88d8BA8b3b790f000CfaDDae45D4e4F", //"0x3cB251c826bD7b5f3617A0CEE364d8602B4EE58F",
    //     LOCK_ADDRESS : "0xD82e554e61215D7ea77D3F637BA79104084f6fc6", //"0x4f7607ff12A3524e462049ab4cB61A97f74b2054", // "0x682340e16C5b94b4B0EAd18bFC31C9B9cd50006d",//"0x783edf2e8673f2e886a942fdF7629634207Ac30D", //0x643C924f71E413cC031Cca4C2f60f602A1310792", //0xa44a318F00322FeF490d16f6ffDEE38F788B9e22", // 0xd915682d1b33e142f0B1F4822502702e11e2F9e8 old
    //     BNB : "0x0000000000000000000000000000000000000000",
    //     // BUSD : "0xd7613f4F96d039f9F15B75D51232719D220B047e",
    //     USDT : "0x8d9f46183A23d81dcCc172C92bDb4553c1b67FFf",
    //     USDC : "0xd7613f4F96d039f9F15B75D51232719D220B047e",
    //     DAI:"0x8d9f46183A23d81dcCc172C92bDb4553c1b67FFf",
    //     AIRDROP_ADDRESS :"0x87980adBff68E5204fe7DDb7C6213e54FD585775",//"0x3b3bCCa9BC1C5d5f22F5110613062f48530C60a7", //"0xF2CD85Bba915Ff7F37B2c343e96809fE314E8b80", //"0x385b0e7d746ed4711ed3e7bea48e2d9b5052373a",
    //     TRANSACTION : "https://testnet.snowtrace.io/tx/",
    //     TokenTracker : "https://testnet.snowtrace.io/token/",
    //     Testnet : "https://testnet.snowtrace.io/address/",
    // },

    // {
    //     NAME: "BSC-Mainnet",
    //     RPC_URL:[
    //         "https://neat-fragrant-crater.bsc-testnet.quiknode.pro/b5baa8a7cdddef6b65cdb7ac9f8e598244df6e4f/",
    //         "https://bsc-testnet.publicnode.com",
    //         "https://data-seed-prebsc-1-s2.bnbchain.org:8545",
    //         "https://bsc-testnet.blockpi.network/v1/rpc/public"],
    //     CHAIN_ID:97,
    //     IMAGE: bsctestnet,
    //     ROUTER: "0x097b0468D402B7a13969C3D8B145717a6ef928DD", //0x15690Bc1eA3083c747A31927a641c0566bf86A10",//"0x29035dEbC68181B33183E3A7fb9291bC2815644F", //pancake
    //     // ROUTER: "0x2a09fba034e26852ff38d5393f3fd15748518791"
    //     LIQUIDITY_TOKEN_ADDRESS : "0xaBa998C38A086e72f5F35A8B13D56B3c97eB418e",
    //     STANDARD_TOKEN_ADDRESS : "0x487e12D2B7128F004E39473D2f0De3C3Ac012C71",
    //     LOCK_ADDRESS : "0xEC12Dc84482668C7D9c4b319bD72F3ab808a44cE", // 0xd915682d1b33e142f0B1F4822502702e11e2F9e8 old
    //     BNB : "0x0000000000000000000000000000000000000000",
    //     // BUSD : "0xbCf448aa88d80C1B7bb8Fb5A1e68cd4B6c11c354",
    //     USDT : "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
    //     USDC : "0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
    //     DAI:"0x0A1F4c4E14Dd83018942c5813768A8bf70b78599",
    //     AIRDROP_ADDRESS : "0xd13BE9C8146c0E99B08Dd8E98544A84caB3E3488", //"0x385b0e7d746ed4711ed3e7bea48e2d9b5052373a",
    //     TRANSACTION : "https://testnet.bscscan.com/tx/",
    //     TokenTracker : "https://testnet.bscscan.com/token/",
    //     Testnet : "https://testnet.bscscan.com/address/",
    // },
    
    // {
    //     NAME: "Avalanche-TEST",
    //     RPC_URL:"https://api.avax-test.network/ext/bc/C/rpc",
    //     CHAIN_ID:43113,
    //     IMAGE: bsctestnet,
    //     ROUTER: "0x29035dEbC68181B33183E3A7fb9291bC2815644F", //pancake
    //     // ROUTER: "0x2a09fba034e26852ff38d5393f3fd15748518791"
    //     LIQUIDITY_TOKEN_ADDRESS : "0x36ff68d44e5A38Ac561900431eDd799781DE2c3f",
    //     STANDARD_TOKEN_ADDRESS : "0xF037798BDdEd40336498d3121dC5392a2E676778",
    //     LOCK_ADDRESS : "0x0D42554AEcff5CB84E16ec6F82f3197B5fF3c2ce", // 0xd915682d1b33e142f0B1F4822502702e11e2F9e8 old
    //     BNB : "0x0000000000000000000000000000000000000000",
    //     BUSD : "0xd7613f4F96d039f9F15B75D51232719D220B047e",
    //     USDT : "0xd7613f4F96d039f9F15B75D51232719D220B047e",
    //     USDC : "0xd7613f4F96d039f9F15B75D51232719D220B047e",
    //     AIRDROP_ADDRESS : "0x3b3bCCa9BC1C5d5f22F5110613062f48530C60a7", //"0x385b0e7d746ed4711ed3e7bea48e2d9b5052373a",
    //     TRANSACTION : "https://testnet.snowtrace.io/tx/",
    //     TokenTracker : "https://testnet.snowtrace.io/token/"
    // },
    // {
    //     NAME: "Arbitrum",
    //     RPC_URL:"https://arb1.arbitrum.io/rpc",
    //     CHAIN_ID:42161,
    //     IMAGE: bsctestnet,
    //     ROUTER: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506", //pancake
    //     // ROUTER: "0x2a09fba034e26852ff38d5393f3fd15748518791"
    //     LIQUIDITY_TOKEN_ADDRESS : "0xf997125D111066E1989c94f18bA097C20ca858Ff",
    //     STANDARD_TOKEN_ADDRESS : "0xc228c9AB8889901C7C6936C6C6B8d5547006d727",
    //     LOCK_ADDRESS : "0x500d3cB1a8709e06C6274CbFa952E4F2a13dd87d", // 0xd915682d1b33e142f0B1F4822502702e11e2F9e8 old
    //     // BNB : "0x0000000000000000000000000000000000000000",
    //     BNB : "0x0000000000000000000000000000000000000000",
    //     DAI  : "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    //     USDT : "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    //     USDC : "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
    //     TRANSACTION : "https://arbiscan.io/tx/",
    //     TokenTracker : "https://arbiscan.io/token/" 
    // },

];

//local
  //  export const API_URL = "http://localhost:7097"



   //demo
   // export const API_URL = "https://backend-lumina.maticz.in"

   //dex-backend-url
   export const API_URL = "https://luminadex-backend.maticz.in/"

  //live
  // export const API_URL = "https://api.lumina.exchange"


//staging
// export const API_URL = "https://apistaging.chainpad.app"
//demo
 // export const FUND_RECEIVER = "0x12ABeD5514FD6F6716F1154a1Be05beD9E1a11dF"
//live
   export const FUND_RECEIVER = "0xeD4fA008cC42503161365e847DAe0e03A3AD2270"




export const COINS = ["BNB", "DAI", "USDT", "USDC", "BNB", "MATIC", "AVAX", "CRO", "FTM"];

export const HC = ["Presale", "Fairlaunch", "Auction", "Subscription"];

export const STATUS = ["Upcoming", "Live", "Ended"];

export const TOKEN_FEE = 0.01; 

export const ZEROTH_ADDRESS = "0x0000000000000000000000000000000000000000"


// export const WBNB_Address = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"; // BSC Mainet

// export const WBNB_Address = "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd";  //BSC Testnet

export const WBNB_Address = "0x1d308089a2d1ced3f1ce36b1fcaf815b07217be3"

export const PROJECT_ID = "b8a1daa2dd22335a2fe1d2e139980ae0"






